import React, { useState } from 'react';
const faqs = [{
  q: "Comment je reçois le Pack après l'achat ?",
  a: "L'accès est immédiat. Dès que vous confirmez le paiement, vous recevez un email avec votre lien de téléchargement et vous pouvez commencer à utiliser le kit en moins de 5 minutes, depuis tablette, mobile ou PC."
}, {
  q: "Est-ce adapté pour les professeurs avec peu d'expérience ?",
  a: "Absolument ! Le kit est conçu aussi bien pour les nouveaux professeurs qui ont besoin de structure, que pour les professionnels avec des années d'expérience qui cherchent à optimiser leur temps. Les 6 volumes incluent des progressions claires du débutant à l'avancé."
}, {
  q: 'Est-ce adapté pour Vinyasa et Hatha ?',
  a: "Oui. Le Pack inclut des volumes spécifiques pour Vinyasa Flow, Hatha Fondamental, Yoga Doux, Power Yoga et Yin. C'est un système complet, pas seulement une modalité."
}, {
  q: 'Les 6 bonus sont-ils inclus dans le prix ?',
  a: 'Oui, les 6 bonus stratégiques (Playlists, Anamnèse, Variations 3 Niveaux, Calendrier Annuel, Script du Premier Cours et Pack de Flyers) sont inclus sans frais supplémentaires dans cette offre de lancement.'
}, {
  q: 'Que faire avec des élèves de différents niveaux en même temps ?',
  a: 'Le Guide des Variations en 3 Niveaux (Bonus 03) résout exactement cela. Vous avez la même posture en version Fondation, Standard et Avancée — vous montrez les 3 et chaque élève choisit celle qui lui correspond.'
}, {
  q: 'Est-ce adapté si je donne des cours en ligne ?',
  a: 'Oui. Les séquences et planifications fonctionnent parfaitement pour les cours en présentiel 1 à 1, en groupe au studio et aussi pour les cours en ligne par Zoom ou vidéo. Vous choisissez le format.'
}, {
  q: 'Dans quel format sont les fichiers ?',
  a: "Tout le matériel est en PDF de haute qualité, optimisé pour visualiser sur tablette, mobile et PC, ou pour imprimer si vous préférez l'avoir en papier au studio. Vous n'avez besoin d'aucun logiciel spécial."
}, {
  q: 'Combien de temps ai-je accès au matériel ?',
  a: "Accès à vie. Une fois que vous le téléchargez, le kit est 100% à vous pour toujours — sans abonnements, sans paiements récurrents, sans dates d'expiration."
}, {
  q: 'Y a-t-il une garantie de remboursement ?',
  a: "Oui, vous avez 7 jours de garantie totale. Si ce n'est pas ce que vous attendiez, nous vous remboursons 100% de votre argent sans questions, sans formulaires et sans démarches compliquées. Notre taux de remboursement est inférieur à 1%."
}, {
  q: 'Comment puis-je payer ? Est-ce sécurisé ?',
  a: 'Nous acceptons les cartes de crédit, débit et méthodes locales selon votre pays. Le paiement de 27€ est traité dans votre devise locale via une passerelle 100% sécurisée et cryptée. Vos données ne sont jamais partagées.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-20 sm:py-24 px-4" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <div className="text-center mb-10 sm:mb-12" data-id="element-154">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-155">
            ❓ Nous répondons à vos questions
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-156">
            Questions Fréquentes
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4 mb-12 sm:mb-16" data-id="element-157">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_8px_24px_-12px_rgba(139,111,191,0.25)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-158">
                <button className="w-full text-left px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-159">
                  <span className={`font-bold text-base sm:text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-160">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-161">
                    +
                  </span>
                </button>
                <div className={`px-5 sm:px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 sm:pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-162">
                  <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-163">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-164">
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_15px_40px_-10px_rgba(15,139,111,0.5)]" data-id="element-165">
            🚀 OUI ! JE VEUX LE PACK COMPLET
          </a>
          <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-166">
            <span data-id="element-167">⚡ Accès immédiat</span>
            <span data-id="element-168">•</span>
            <span data-id="element-169">🛡️ Garantie 7 jours</span>
            <span data-id="element-170">•</span>
            <span data-id="element-171">💳 27€ paiement unique</span>
          </p>
        </div>
      </div>
    </section>;
}